import React,{useEffect, useState} from 'react';

import CSS from './index.less';
import Loading from '@/components/Loading';

const PageLoading = (props) => {
  const {visible=true} = props;
  if(!visible){
    return '';
  }
  return (
    <div className={CSS.wrap } >
      <div className={CSS.box} data-show={visible}>
        <Loading />
      </div>
    </div>
  );
};

export default React.memo(PageLoading);
